import { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { isTtsAvailable, speak } from './speechSynthesis';

export interface TtsPlayerProps { text: string; }

export function TtsPlayer({ text }: TtsPlayerProps) {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    setAvailable(isTtsAvailable());
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      const onVoicesChanged = () => setAvailable(isTtsAvailable());
      window.speechSynthesis.addEventListener?.('voiceschanged', onVoicesChanged);
      return () => window.speechSynthesis.removeEventListener?.('voiceschanged', onVoicesChanged);
    }
  }, []);

  return (
    <Button
      type="button"
      color="light"
      size="sm"
      aria-label={available ? 'Ascolta' : 'Ascolta (TTS non disponibile)'}
      title={available ? 'Riproduci con voce italiana del browser' : 'TTS non disponibile in questo browser'}
      disabled={!available}
      onClick={() => speak(text)}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
    >
      <span>▶</span>
      <span>ascolta</span>
    </Button>
  );
}
